import useDisclosure from '@/hooks/useDisclosure' 
import InfoOperationDialog from '../infoOperation'
import { Cockpit } from '@/api/business/cockpit/type'
import { TypographyP } from '@/components/ui/typography';
import { useState } from 'react';
import { validadeStatusCardOperation, calcTime } from './validateOperationCard';
import { Eye } from 'lucide-react';
import OperationHub from './components/operationHub';
import InformOperation from './components/informOperation';

type CardProps = {
    operation: Cockpit; 
};
  


const Operation = ({ operation } : CardProps ) => { 
    const {
        isOpen,
        onClose,
        onOpen,
    } = useDisclosure()

    const {
        isOpen: isOpenOpHub,
        onClose: onCloseOpHub,
        onOpen: onOpenOpHub,
    } = useDisclosure()

    const {
        isOpen: isOpenInformOp,
        onClose: onCloseInformOp,
        onOpen: onOpenInformOp,
    } = useDisclosure()

    const [selectedNF, setSelectedNF] = useState('') 
    return (
        <div className="flex flex-row gap-2 border rounded-lg p-2 pt-2 bg-gray-800">
            <div className="flex flex-col w-full gap-4"> 

                <div className={`flex-1 flex justify-center py-2 px-8 rounded-lg border border-gray-400 relative cursor-pointer ${operation.OPERATIONS[0].NF.DD_PROCESSO_HUB ? 'bg-gray-100' : ''}`} onClick={() => { onOpenOpHub()}}>
                    <TypographyP className={`text-wrap text-gray-100 font-medium text-center ${operation.OPERATIONS[0].NF.DD_PROCESSO_HUB ? 'text-black' : ''}`}>{operation.OPERATIONS[0].DD_NUMERO_ROTA} - {operation.OPERATIONS[0].NF.NM_RAZAO_SOCIAL}</TypographyP>
                    <Eye className={`absolute right-1 h-5 ${operation.OPERATIONS[0].NF.DD_PROCESSO_HUB ? 'text-black' : ''}`}/>
                </div>
                <div className='flex gap-2'>
                    {operation.OPERATIONS[0].hasOwnProperty('SK_OPERACAO') ? operation.OPERATIONS.map((column, index) => (
                        <div
                            key={index}
                            className={`flex-1 border rounded-lg p-2 ${validadeStatusCardOperation(column, operation.OPERATIONS, index)} ${column.NF.DD_DOC ? 'cursor-pointer' : ''}`}
                            onClick={() => { 
                                if(column.NF.SK_NF){
                                    setSelectedNF(column.NF.SK_NF) 
                                    onOpen()
                                } 
                            }}
                        >
                            <div className='grid'>
                                <div className="flex justify-center">
                                    <div className="flex items-center justify-center">
                                        <TypographyP className="text-green-50 px-2 text-center truncate hover:text-gray-100">
                                            {column.NF.DD_DOC}
                                        </TypographyP>
                                    </div>
                                    <div className="flex items-center justify-center">
                                        <TypographyP className="text-green-50 text-center truncate hover:text-gray-100">
                                            |
                                        </TypographyP>
                                    </div>
                                    <div className="flex items-center justify-center">
                                        <TypographyP className="text-green-50 px-2 text-center truncate hover:text-gray-100">
                                            {column.ABREVIATURA_EMPRESA_DESTINO}
                                        </TypographyP>
                                    </div>
                                    <div className="flex items-center justify-center">
                                        <TypographyP className="text-green-50 text-center truncate hover:text-gray-100">
                                            |
                                        </TypographyP>
                                    </div>
                                    <div className="flex items-center justify-center">
                                        <TypographyP className="text-green-50 px-2 text-center truncate hover:text-gray-100">
                                            {column.NF.DD_DOC_SEQUENCIA}
                                        </TypographyP>
                                    </div>
                                </div>
                                <div className='flex justify-center'>
                                    {calcTime(column, operation.OPERATIONS, index)}
                                </div>
                            </div>
                        </div>
                    )) : (
                        <div 
                            className={`flex-1 border rounded-lg p-2 bg-gray-500 cursor-pointer`} 
                            onClick={() => {   
                                onOpenInformOp() 
                            }}
                        >
                            <div className='grid'>
                                <div className="flex justify-center">
                                    <div className="flex items-center justify-center">
                                        <TypographyP className="text-green-50 px-2 text-center truncate hover:text-gray-100">
                                            {operation.OPERATIONS[0].NF.DD_DOC}
                                        </TypographyP>
                                    </div>
                                    <div className="flex items-center justify-center">
                                        <TypographyP className="text-green-50 text-center truncate hover:text-gray-100">
                                            | {operation.OPERATIONS[0].NF.DD_LETRA_PEDIDO} |
                                        </TypographyP>
                                    </div>
                                    <div className="flex items-center justify-center">
                                        <TypographyP className="text-green-50 px-2 text-center truncate hover:text-gray-100">
                                            Necessário informar Operação
                                        </TypographyP>
                                    </div> 
                                </div> 
                            </div>
                        </div>
                    )}
                </div>
            </div>
            
            {isOpen && ( 
                <InfoOperationDialog 
                    isOpen={isOpen}
                    onClose={onClose}
                    SK_NF={selectedNF}
                />
            )}

            {isOpenOpHub && ( 
                <OperationHub 
                    isOpen={isOpenOpHub}
                    onClose={onCloseOpHub} 
                    SK_NF={operation.OPERATIONS[0].NF.SK_NF}
                    DD_PROCESSO_HUB={operation.OPERATIONS[0].NF.DD_PROCESSO_HUB}
                />
            )}
            {isOpenInformOp && ( 
                <InformOperation  
                    NF={operation.OPERATIONS[0].NF} 
                    isOpen={isOpenInformOp}
                    onClose={onCloseInformOp} 
                />
            )}
        </div>
    )
}

export default Operation
